import { combineReducers, createStore, applyMiddleware } from 'redux';
import reduxPromise from 'redux-promise';
import reduxThunk from 'redux-thunk';
import dashboard from '../pages/dashboard/redux/dashboardReducer';
import bi from '../components/bi/dashboardReducer';
import loading from '../components/loading/loadingReducer';
import router from '../router/redux/routerReducer';
import chamados from "../pages/chamados/redux/chamadosReducer";
import users from "../pages/usuariosV2/redux/usuariosReducer";
import alterarDados from "../pages/gestaoUsuarios/alterarDados/redux/editarMeusDadosReducer";
import listaDistribuicao from "../pages/microsoft365/listaDeDistribuicao/redux/listaDistribuicaoReducer";
import { composeWithDevTools } from 'redux-devtools-extension';

var reducers = combineReducers({
    bi,
    dashboard,
    loading,
    router,
    chamados,
    users,
    alterarDados,
    listaDistribuicao
})

export default createStore(reducers, composeWithDevTools(
    applyMiddleware(reduxThunk, reduxPromise)
));
